import { css } from '@emotion/react'

export const buttons = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
`

export const button = css`
  width: 200px;
`

export const iconPlus = css`
  height: 22px !important;
  width: auto !important;
`

export const actionButtons = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  margin-top: 15px;
`

export const addButton = css`
  margin-top: 15px;
`
